
export const RESET = '[Forgot Password] Reset';
export const GET_VERIFICATION_CODE = '[Forgot Password] Get verification code';
export const SET_ERROR_MESSAGE = '[Forgot Password] Set Error Message';
export const SET_USER_DETAILS = '[Forgot Password] Set user details';
export const SET_VERIFICATION_DETAILS = '[Forgot Password] Set verification details';